import React from 'react'

const HeadlineSection = ({ title }) => {
    return (
        <h1 className='sm:text-3xl text-2xl font-semibold text-center mb-7'>{title}</h1>
    )
}

export default HeadlineSection